<template>
   <div id="help-about" class="space-about">
    <vs-list>
      <vs-list-item :title="$t('HELP_VERSION').Item_Version" subtitle="">
        <span>{{version}}</span>
      </vs-list-item>
      <vs-list-item :title="$t('HELP_VERSION').Item_Browser" subtitle="">
        <span>{{browserName}}</span>
      </vs-list-item>
      <vs-list-item :title="$t('HELP_VERSION').Item_System" subtitle="">
        <span>{{platform}}</span>
      </vs-list-item>
      <vs-list-item :title="$t('HELP_VERSION').Item_Resolution" subtitle="">
        <span>{{screenSize}}</span>
      </vs-list-item>
    </vs-list>
  </div>
</template>

<script>
import BrowserInfoHelper from "../../../helpers/browser-info-helper";
export default {
  props: {

  },
  data() {
    return {
    }
  },
  computed: {
    platform() {
      return BrowserInfoHelper.getPlatform();
    },
    screenSize() {
      return BrowserInfoHelper.getScreenSize();
    },
    browserName() {
      return BrowserInfoHelper.getBrowserName();
    },
    version() {
      return this.$config.version;
    }
  }
};
</script>

<style>
.help-version-logo {
    display: flex;
    justify-content: center;
}
.help-version-logo img {
  width: 120px;
}
.vs-list {
    line-height: 40px;
}


</style>
